/* src/app/components/controls/dialogs/sem-audit-log/sem-audit-log.component.css */
.audit-log-dialog {
  min-width: 80vw;
  max-width: 95vw;
}
.table-wrapper {
  overflow-x: auto;
}
.table-wrapper table {
  width: 100%;
  min-width: 800px;
}
.table th:nth-child(3),
.table td:nth-child(3) {
  width: 40%;
  min-width: 300px;
  max-width: none;
  white-space: normal;
  word-wrap: break-word;
}
.table th:nth-child(1),
.table td:nth-child(1) {
  width: 20%;
  min-width: 150px;
}
.table th:nth-child(2),
.table td:nth-child(2) {
  width: 20%;
  min-width: 120px;
}
.table th,
.table td {
  vertical-align: middle;
  text-align: center;
}
.table th p,
.table td {
  vertical-align: middle;
}
.table td p {
  margin: 0;
  line-height: 1.4;
  vertical-align: middle;
}
.changes-column {
  font-size: 0.9em;
  line-height: 1.3;
}
.dropdown-container {
  position: relative;
  display: inline-block;
}
.dropdown-toggle {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.85em;
  cursor: pointer;
  color: #495057;
  transition: all 0.2s ease;
}
.dropdown-toggle:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}
.dropdown-toggle.open {
  background: #007bff;
  color: white;
  border-color: #007bff;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  min-width: 200px;
  max-width: 400px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
}
.dropdown-item {
  padding: 6px 12px;
  font-size: 0.8em;
  border-bottom: 1px solid #f8f9fa;
  color: #495057;
  line-height: 1.3;
}
.dropdown-item:last-child {
  border-bottom: none;
}
.dropdown-item:hover {
  background: #f8f9fa;
}
.table tbody tr {
  transition: background-color 0.2s ease;
}
.table tbody tr.clickable {
  cursor: pointer;
}
.table tbody tr.clickable:hover {
  background-color: #f8f9fa;
  color: #495057;
}
.table tbody tr.non-clickable {
  cursor: default;
  opacity: 0.7;
}
.table tbody tr[title] {
  position: relative;
}
.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin: 15px 0;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
}
.pagination-controls button {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s ease;
}
.pagination-controls button:hover:not(:disabled) {
  background: #0056b3;
}
.pagination-controls button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}
.pagination-controls span {
  font-size: 0.9em;
  color: #495057;
  font-weight: 500;
}
/*# sourceMappingURL=sem-audit-log.component.css.map */
